import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loading" }
const _hoisted_2 = {
  key: 0,
  class: "loader"
}
const _hoisted_3 = {
  key: 0,
  class: "lds-spinner"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_16 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({ 'tirscript-loading': _ctx.loading })
            }, [
              (_ctx.loading)
                ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
                    _createElementVNode("div", _hoisted_1, [
                      (_ctx.loaderType == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.loaderType == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_16))
                      : _createCommentVNode("", true),
                    _createTextVNode("  " + _toDisplayString(_ctx.loadingMessage), 1)
                  ])
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? _renderSlot(_ctx.$slots, "error", { key: 1 }, () => [
              _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
            ])
          : _createCommentVNode("", true),
        (_ctx.ok)
          ? _renderSlot(_ctx.$slots, "ok", { key: 2 }, () => [
              _createTextVNode(_toDisplayString(_ctx.okMessage), 1)
            ])
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? _renderSlot(_ctx.$slots, "default", { key: 3 })
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}